import { Badge, Checkbox } from '@zond/ui';
import { useTranslation } from 'react-i18next';

interface IntegrationItemProps {
  id: string;
  name: string;
  description?: string;
  icon: string;
  isSelected: boolean;
  onToggle: (id: string) => void;
  isInactive?: boolean;
}

export function IntegrationItem({
  id,
  name,
  description,
  icon,
  isSelected,
  onToggle,
  isInactive = false,
}: IntegrationItemProps) {
  const { t } = useTranslation('integrations');
  return (
    <div
      key={id}
      className={`flex items-center gap-3 p-3 rounded-lg border transition-colors cursor-pointer hover:bg-accent overflow-hidden w-full ${
        isSelected ? 'bg-accent border-primary' : ''
      }`}
      onClick={() => onToggle(id)}
    >
      <Checkbox checked={isSelected} onCheckedChange={() => onToggle(id)} className="shrink-0" />
      <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary font-medium">
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-medium truncate">{name}</p>
        {description && <p className="text-sm text-muted-foreground truncate">{description}</p>}
      </div>
      {isInactive && (
        <Badge variant="secondary" className="shrink-0">
          {t('integrationItem.inactive')}
        </Badge>
      )}
    </div>
  );
}
